import { useContext } from 'react'

import Modal, { ModalType } from '@/components/view/layouts/modal/Modal'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import VisualCssForm from '@/components/container/form/modules/recommend/visualCss/VisualCssForm'
import { VisualCssEditorModalContext } from '@/components/container/modal/widget/visualCssEditor/VisualCssEditorModalProvider'

const VisualCssEditorModal = () => {
  const { modal, showing, hide } = useContext(VisualCssEditorModalContext)

  return (
    <Modal show={showing} type={ModalType.LARGE}>
      <ModalHeader text={'ビジュアルCSSエディター'} onClickClose={hide} />
      {modal.showing && (
        <VisualCssForm
          values={{
            siteId: modal.siteId,
            widgetPageId: modal.widgetPageId,
            layoutType: modal.layoutType,
            titleTemplate: modal.titleTemplate,
            maxItems: modal.maxItems,
            useTitle: modal.useTitle,
            currentCss: modal.currentCss
          }}
          hide={hide}
          onApply={modal.onApply}
        />
      )}
    </Modal>
  )
}

export default VisualCssEditorModal
